<template>
<v-layout>
  <v-flex shrink class="mt-2 ml-2 pr-0">
    <div :class="'borderAvatar'" @click="gotoProfile(itemData.User.Id)" style="cursor:pointer">
      <div class="module">
        <v-avatar size="55">
          <v-img :src="itemData.User.Avatar" />
        </v-avatar>
      </div>
    </div>
  </v-flex>
  <v-flex grow class="mt-2">
    <div
      @click="gotoProfile(itemData.User.Id)"
      style="line-height: 1; cursor:pointer"
      class="black--text"
    >
      <span
        style="font-size: 13px; cursor: pointer"
        class="text-capitalize defaultColor--text font-weight-bold"
      >
        {{ itemData.User.FullName }}
         ·
        <departmant-icon :departmentName="itemData.User.Department" />
      </span>
      <br />
      <span
        style="font-size: 13px"
        class="text-capitalize defaultColor--text font-weight-regular"
      >
        {{ itemData.User.Company }}
      </span>
      <br />
      <!-- <span class="caption grey--text">{{ getDateFormat(itemData.CreatedAt) }}</span> -->
      <span class="defaultColor--text font-weight-light" style="font-size: 12px !important;">{{moment(itemData.CreatedAt).locale('tr').fromNow()}}</span>
    </div>
  </v-flex>
  </v-layout>
</template>

<script>
import DepartmantIcon from "../General/DepartmantIcon.vue";
export default {
  data() {
    return {};
  },
  props: {
    itemData: Object,
  },
  components: {
    DepartmantIcon
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>
